import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  clearSelectedVisitTaskAction,
  clearVisitTasksActions,
  getVisitTasksActions,
} from '../../../redux/actions/visitTasksActions';

const useFetchVisitTasks = (visitId, vin) => {
  const dispatch = useDispatch();
  const visitTasks = useSelector((state) => state.visitTasks?.visitTasks);
  const loading = useSelector((state) => state.visitTasks?.loading);

  const fetchVisitTasks = useCallback(async () => {
    await dispatch(getVisitTasksActions(visitId, vin));
  }, [visitId, vin, dispatch]);

  useEffect(() => {
    fetchVisitTasks();
  }, [fetchVisitTasks]);

  useEffect(() => {
    return () => {
      dispatch(clearVisitTasksActions());
      dispatch(clearSelectedVisitTaskAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchVisitTasks();
  };

  return { loading, visitTasks, refresh };
};

export default useFetchVisitTasks;
